const Category = [
  {
    display: "Crop Tops",
    categorySlug: "crops",
  },
  {
    display: "Cargos",
    categorySlug: "cargos",
  },
  {
    display: "Jeans",
    categorySlug: "jeans",
  },
  {
    display: "Joggers",
    categorySlug: "joggers",
  },
  {
    display: "Hoodies",
    categorySlug: "hoodies",
  },
  {
    display: "Trousers",
    categorySlug: "trouser",
  },
];

export default Category;
